module.exports = __webpack_public_path__ + "static/media/apartment6.2d56d205.jpg";